import OperationsPageShell from '../components/OperationsPageShell';

const vehicles = [
  { name: 'Truck 12', number: 'TZ-2408', status: 'Available', utilization: '78%', ownership: 'Company', todayKm: 'Not available' },
  { name: 'Truck 19', number: 'TZ-3412', status: 'Enroute', utilization: '64%', ownership: 'Not available', todayKm: 'Not available' },
  { name: 'Truck 27', number: 'TZ-8804', status: 'Maintenance', utilization: '0%', ownership: 'Rental', todayKm: 'Not available' },
];

const statusClassMap: Record<string, string> = {
  Available: 'badge-light-success',
  Enroute: 'badge-light-primary',
  Maintenance: 'badge-light-warning',
};

const Vehicles = () => (
  <OperationsPageShell
    title="Vehicles"
    subtitle="Fleet overview, utilization, and operational vehicle state."
    action={
      <button type="button" className="uw-btn uw-btn-light uw-btn-sm btn btn-sm btn-light">
        ↻ Refresh
      </button>
    }
  >
    <div className="table-responsive">
      <table className="table align-middle gs-0 gy-4">
        <thead>
          <tr>
            <th>Vehicle</th>
            <th>Number</th>
            <th>Status</th>
            <th>Utilization</th>
            <th>Ownership</th>
            <th>Today KM</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map((vehicle) => (
            <tr key={vehicle.number}>
              <td>{vehicle.name}</td>
              <td>{vehicle.number}</td>
              <td>
                <span className={`badge ${statusClassMap[vehicle.status] || 'badge-light-secondary'}`}>
                  {vehicle.status}
                </span>
              </td>
              <td>{vehicle.utilization}</td>
              <td>{vehicle.ownership}</td>
              <td>{vehicle.todayKm}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </OperationsPageShell>
);

export default Vehicles;
